export default "__VITE_ASSET__1449c040__"